import {Injectable, Inject} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG, IAppConfig } from './../app.config';
import { publishReplay, refCount } from 'rxjs/operators';

type KeyedResultCache<T> = {
  [P: string]: T;
}
@Injectable()
export class StateService {
  private StatesByCountry: KeyedResultCache<Observable<any[]>>;

  constructor(
    private Http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    this.StatesByCountry={};
  }

  getStateList(countrycode:string){
    if(!(countrycode in this.StatesByCountry)) {
      this.StatesByCountry[countrycode]=this.Http.get(this.config.apiEndpoint +'stateStore/?countrycode='+countrycode).pipe(
        publishReplay(1),
        refCount()
      )
      .catch(this.handleErrorObservable);
    }
    return this.StatesByCountry[countrycode];
  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/state.service.ts